import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { PublicAvailability } from '../enums/public-availability';

@Injectable({
  providedIn: 'root',
})
export class PublicSalesAvailabilityLabelProviderService {
  /* prettier-ignore */
  private readonly entries = new Map<PublicAvailability, string>([
    [PublicAvailability.Unavailable, 'Wyprzedany'],
    [PublicAvailability.Available, 'Dostępny']
  ]);

  public label(status: PublicAvailability): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${status}" not found.`);
    }

    return of(entry);
  }
}
